import { render, staticRenderFns } from "./HomeResourceCard.vue?vue&type=template&id=612c4bfa&"
import script from "./HomeResourceCard.vue?vue&type=script&lang=js&"
export * from "./HomeResourceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports